export default __webpack_public_path__ + "static/9-f8001ef26d7b40c281ee575e038d0120.webp";